import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {isBoolean} from 'lodash';
import {ReportField} from 'src/app/reports/interfaces/report-field.interface';
import {GroupedAttributes} from 'src/app/shared/interfaces/grouped-attributes.interface';
import {flatArray} from '../../helper/arrayHelper';

@Component({
    selector: 'app-grouped-attributes-list',
    templateUrl: './grouped-attributes-list.component.html',
    styleUrls: ['./grouped-attributes-list.component.scss'],
})
export class GroupedAttributesListComponent implements OnInit {

    @Input() fields: Array<ReportField> = [];
    @Input() showOptionalFields: boolean = false;
    @Input() groupedAttributes: Array<GroupedAttributes> = [];
    @Input() isGroupedAttributesList: boolean = false;
    @Output() checkAttribute: EventEmitter<number[]> = new EventEmitter();
    @Output() unCheckAttribute: EventEmitter<number[]> = new EventEmitter();
    public groupedAttributesDisplayed: Array<GroupedAttributes> = [];
    private storageKey = 'report_selected_fields';

    constructor() {
    }

    ngOnInit() {
        this.groupedAttributesDisplayed = this.getAllAttributesCopy();
    }

    public searchAttributes(event) {
        const query = event.target.value.toLowerCase();
        this.groupedAttributesDisplayed = this.getAllAttributesCopy()
            .filter((ga) =>
                (ga.type.toString().toLowerCase().indexOf(query) > -1) ||
                (ga.attributes.some(a => a.name.toString().toLowerCase().indexOf(query) > -1))
            );
        this.groupedAttributesDisplayed.forEach(ga => {
            ga.attributes = ga.attributes.filter(a => a.name.toString().toLowerCase().indexOf(query) > -1);
        });
    }

    public listAttributes(groupIndex: number) {
        this.groupedAttributesDisplayed[groupIndex].listAttributes = !this.groupedAttributesDisplayed[groupIndex].listAttributes;
    }

    public changeChecked(check: any, groupIndex: number, attributeIndex: number = null) {
        check = check === undefined ? true : !check;
        let attributeIds: number[];
        if (isBoolean(check)) {
            if (attributeIndex === null) {
                attributeIds = [];
                this.groupedAttributesDisplayed = this.getAllAttributesCopy();
                this.groupedAttributesDisplayed[groupIndex].checked = check;
                this.groupedAttributesDisplayed[groupIndex].attributes.forEach((attribute) => {
                    attribute.checked = check;
                    attributeIds.push(attribute.id);
                });

                check ? this.checkAttribute.emit(attributeIds) : this.unCheckAttribute.emit(attributeIds);
            } else {
                attributeIds = [];
                this.groupedAttributesDisplayed = this.getAllAttributesCopy();
                this.groupedAttributesDisplayed[groupIndex].attributes[attributeIndex].checked = check;
                attributeIds.push(this.groupedAttributesDisplayed[groupIndex].attributes[attributeIndex].id);
                check ? this.checkAttribute.emit(attributeIds) : this.unCheckAttribute.emit(attributeIds);

                this.groupedAttributesDisplayed[groupIndex].checked = this.groupedAttributesDisplayed[groupIndex].attributes.some((attribute) => attribute.checked);
            }
        }
        this.getRelatedAttributesBySelectedOne(check, groupIndex, attributeIndex);
    }

    public toggleSelectedField(selected: boolean): void {
        this.fields.forEach((field) => (field.selected = selected));
    }

    public selectField(field): void {
        field.selected = !field.selected;
        localStorage.setItem(this.storageKey, JSON.stringify(this.fields.filter((f) => f.selected).map((f) => f.id)));
    }

    public checkAllAttributes() {
        this.groupedAttributesDisplayed.map(ga => {
            ga.checked = true;
            ga.attributes.map(a => {
                a.checked = true;
            })
        });
        const attributeIds = flatArray(this.groupedAttributesDisplayed.map(ga => ga.attributes.map(a => a.id)));
        this.checkAttribute.emit(attributeIds);
    }

    public unCheckAllAttributes() {
        this.groupedAttributesDisplayed.map(ga => {
            ga.checked = false;
            ga.attributes.map(a => {
                a.checked = false;
            })
        });
        this.groupedAttributes.map(ga => {
                ga.checked = false;
                ga.attributes.map(a => {
                    a.checked = false;
                })
            }
        );
        const attributeIds = flatArray(this.groupedAttributesDisplayed.map(ga => ga.attributes.map(a => a.id)));
        this.unCheckAttribute.emit(attributeIds);
        this.groupedAttributesDisplayed = this.getAllAttributesCopy();
    }

    private getRelatedAttributesBySelectedOne(check: any, groupIndex: number, attributeIndex: number = null) {
        if (check === true) {
            let displayedAttributes = this.getAllAttributesCopy();
            if (attributeIndex === null) {
                let ids = displayedAttributes[groupIndex] !== null
                    ? displayedAttributes[groupIndex].attributes.map(a => a.id)
                    : new Array<number>();

                let alreadyCheckedIds = new Array<number>();
                Object.keys(displayedAttributes).forEach((key) => {
                    const checkedIds = displayedAttributes[key].attributes
                        .filter((attribute) => attribute.checked && !ids.includes(attribute.id))
                        .map(a => a.id);
                    alreadyCheckedIds = alreadyCheckedIds.concat(checkedIds);
                });
                ids.push(...alreadyCheckedIds);

                Object.keys(displayedAttributes).forEach((key) => {
                    displayedAttributes[key].attributes = displayedAttributes[key].attributes.filter((attribute) => {
                        return attribute.relatedAttributes.some((relatedAttribute) => ids.includes(relatedAttribute));
                    });
                    displayedAttributes[key].partialChecked = displayedAttributes[key].attributes.some((attribute) => attribute.checked);
                    displayedAttributes[key].checked = displayedAttributes[key].attributes.every((attribute) => attribute.checked);
                });
            } else {
                let ids = new Array<number>();
                if (displayedAttributes[groupIndex] !== null && displayedAttributes[groupIndex].attributes[attributeIndex] !== null)
                    ids.push(displayedAttributes[groupIndex].attributes[attributeIndex].id);

                let alreadyCheckedIds = new Array<number>();
                Object.keys(displayedAttributes).forEach((key) => {
                    const checkedIds = displayedAttributes[key].attributes
                        .filter((attribute) => attribute.checked && !ids.includes(attribute.id))
                        .map(a => a.id);
                    alreadyCheckedIds = alreadyCheckedIds.concat(checkedIds);
                });
                ids.push(...alreadyCheckedIds);
                Object.keys(displayedAttributes).forEach((key) => {
                    displayedAttributes[key].attributes = displayedAttributes[key].attributes.filter((attribute) => {
                        return attribute.relatedAttributes.some((relatedAttribute) => ids.includes(relatedAttribute));
                    });
                    displayedAttributes[key].partialChecked = displayedAttributes[key].attributes.some((attribute) => attribute.checked);
                    displayedAttributes[key].checked = displayedAttributes[key].attributes.every((attribute) => attribute.checked);
                });
            }
            this.groupedAttributesDisplayed = displayedAttributes;
        } else {
            Object.keys(this.groupedAttributesDisplayed).forEach((key) => {
                this.groupedAttributesDisplayed[key].partialChecked = this.groupedAttributesDisplayed[key].attributes.some((attribute) => attribute.checked);
                this.groupedAttributesDisplayed[key].checked = this.groupedAttributesDisplayed[key].attributes.every((attribute) => attribute.checked);
            });
        }
    }

    private getAllAttributesCopy(): GroupedAttributes[] {
        return JSON.parse(JSON.stringify(this.groupedAttributes));
    }
}
